import * as actionTypes from "./actionTypes";
import admSvc from "../../axios-admsvc";
import { SUCCESS } from "../../shared/Constants";

export const createIncident = (userData) => {
  let requestUrl = null;
  return (dispatch) => {
    dispatch(createIncidentStart());
    requestUrl = "/incident/servicenow/create";
    admSvc
      .post(requestUrl, userData)
      .then((response) => {
        if (
          response.data.status.message === SUCCESS &&
          response.data.payload &&
          response.data.payload.incidentNumber
        ) {
          // console.log("[Member Reducer] enableDisableAccount: response: inside if block");
          // let eligInfo = {"uuid": userData.hsid}
          // dispatch(selectMember(eligInfo));
          dispatch(createIncidentSuccess(response.data.payload.incidentNumber));
          // dispatch(setInciden tFormType("details")); // this is needed if we need to have add, edit and details functionality in future

        } else {
          const msg = response.data?.error?.errorDesc?.replace('null','') || "Failed to create Incident";
          dispatch(createIncidentFailure(msg));
        }
      })
      .catch((error) => {
        const msg = error?.response?.data?.error?.errorMsg || "Failed to create Incident - server error";
        dispatch(createIncidentFailure(msg));
      });
  };
};

export const getServiceNowAgent = () => {
  let requestUrl = null;
  return (dispatch) => {
    dispatch(toggleIncidentLoader(true));
    requestUrl = "/incident/servicenow/agent";
    admSvc
      .get(requestUrl)
      .then((response) => {
        if (
          response.data.payload &&
          response.data.payload.employee_number
        ) {
          dispatch(setAgentEmployeeId(response.data.payload.employee_number));
        }
        dispatch(toggleIncidentLoader(false));
      })
      .catch((error) => {
        dispatch(toggleIncidentLoader(false));
      });
  };
};

export const toggleIncidentLoader = (flag) => {
  return {
    type: actionTypes.SHOW_INCIDENT_LOADER,
    flag,
  };
}

export const createIncidentStart = () => {
  return {
    type: actionTypes.CREATE_SERVICE_NOW_START,
  };
};

export const setAgentEmployeeId = (employeeId) => {
  return {
    type: actionTypes.SET_USER_EMPLOYEEID,
    employeeId
  };
};

export const createIncidentSuccess = (incident) => {
  return {
    type: actionTypes.CREATE_SERVICE_NOW_SUCCESS,
    incident: incident,
  };
};

export const createIncidentFailure = (error) => {
  return {
    type: actionTypes.CREATE_SERVICE_NOW_FAILURE,
    error,
  };
};

export const resetIncidentDetails = () => {
  return {
    type: actionTypes.RESET_INCIDENT_DETAILS,
  };
};

export const setIncidentFormType = (formType) => {
  return {
    type: actionTypes.INCIDENT_FORM_TYPE,
    formType,
  };
};
